import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

@connect((store) => {
    return {
        locations: store.location.locations,
        date: store.meta.date,
        pregnancyTitle: store.meta.pharmacyListingTitle
    };
})
class LocationPage extends Component { 
    componentWillMount() {
        document.body.style.backgroundColor = '#fff';
        document.body.style.alignItems = 'baseline';
        document.getElementById('root').className='container-fluid';
        document.getElementById('root').style.display = 'block';
        var body = document.getElementsByTagName('body')[0];
        body.style.backgroundImage = 'none';
    }

    componentWillReceiveProps() {
        document.getElementById('root').style.display = 'block';
    }

    componentWillUnmount() {
        document.body.style.backgroundColor = '#34B1EE';
        document.body.style.alignItems = 'center';
        document.getElementById('root').className='container';
        document.getElementById('root').style.display = 'flex';
        var body = document.getElementsByTagName('body')[0];
        body.style.backgroundImage = 'url(/staging/images/EasyECBG.jpg)';
    }
    
    render() {
        const query = new URLSearchParams(this.props.location.search);
        
        let date = new Date();
        let day = date.getDay();
        let hours = date.getHours();
        let mins = date.getMinutes();

        let now = hours + "." + mins;

        let location = query.get('id');
        let locationInfo = this.props.locations[location];
        let openingTimes = locationInfo.openingTimes[day];

        let openText = null;
        if (now > openingTimes[1] && now < openingTimes[2]) {

            let closingTime = openingTimes[2];

            if (openingTimes[2] > 12) {
                if (openingTimes[2] === 24) {
                    closingTime = "midnight"
                } else {
                    closingTime = openingTimes[2] - 12 + "pm";
                }
            }

            openText =             
                <p className="location__info location__info--open">Open now  
                    <span className="location__closing-time"> closing at {closingTime}</span>
                </p>;
        } else {
            openText = 
                <p className="location__info location__info--closed">Closed now</p>;
        }

        let price = null;

        if (this.props.pregnancyTitle != 'Buy a pregnancy test') {
            price = <p className="location__info location__info--price">{locationInfo.price}</p>;
        }

        //TODO: move to a helper function
        let encodedAddress =  encodeURIComponent(locationInfo.address.trim());
        let mapSrc = "https://www.google.com/maps/embed/v1/place?q="
                     + encodedAddress +
                     "&key=AIzaSyCJBUcTZJ3U_fRXhIgzlyb_lDB8ijdu6nQ";

        let directionsSrc = "https://www.google.com/maps/dir/?api=1&destination=" + encodedAddress;


        return (
            <div>
                <iframe className="location__map" frameBorder="0" src={mapSrc} allowFullScreen></iframe>
                <div className="container">
                    <div className="location__details row">
                        <div className="col">
                            <p className="location__info location__info--name">{locationInfo.displayName}</p>
                            {openText}
                            {price}
                            <p className="location__info location__info--phone">{locationInfo.phone}</p>
                            <p className="location__info location__info--address">{locationInfo.address}</p>
                        </div>
                        {/* <div className="col">
                            <p className="location__distance">0.3 miles away</p>
                        </div> */}
                    </div>
                    <div className="location__actions row">
                        {/* <div className="col text-center">
                            <a className="ec__button--location ec__button--call">Call</a>
                        </div> */}
                        <div className="col text-center">
                            <a href={directionsSrc} target="_blank" rel="noopener"
                                className="ec__button--location ec__button--directions">
                                Directions
                            </a>
                        </div>
                        <div className="col text-center">
                            <a href={locationInfo.moreInfoLink} target="_blank" rel="noopener"
                                className="ec__button--location ec__button--info">
                                More Info
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LocationPage;


// WEBPACK FOOTER //
// ./src/components/screens/LocationPage.js